// import { decodeUrlParams, encodeUrlParams, checkIsBase64 } from '../middleware/encryption';

const postionRegex = /^position_(\d+)$/;
const jobmeta = /J\d*$/;

const routesMap = {
    position_management: {
        ad_management: {
            name: '广告发布',
            applicant: '应聘者',
            innerRegexRoute: {
                regex: postionRegex,
                detail: '职位详情',
                ads: '职位广告',
                records: '职位记录',
                publish: '职位发布',
            },
        },
        applications: {
            name: '职位申请',
            create: '新建需求',
            innerRegexRoute: {
                regex: jobmeta,
                edit: '编辑需求',
                detail: '需求详情',
                append: '追加需求',
            },
        },
    },
    socialRecrit: {
        applicant: '应聘者',
        interview: {
            name: '面试',
            interviewDetail: '面试详情',
        },
    },
    talentPool: {
        talentPoolList: '全部公共人才',
        myWatches: '我关注的人才',
        talentPoolBlacklist: '黑名单',
    },
    setting: {
        name: '设置',
        hunter: {
            companies: '猎头公司列表',
        },
        notifyTemplate: '通知模板',
        account: '账号管理',
        recruiter: '招聘团队及RT管理',
        dailyFeedback: {
            dailyFeedbackList: '日常反馈列表',
        },
    },
    statistics: {
        incident: {
            name: '招聘事件分析',
            interviewDatas: '面试数据分析',
        },
        internal: {
            name: '内部推荐分析',
            integration: '内推积分分析',
            interData: '内推数据分析',
        },
        channel: {
            name: '渠道效果分析',
            hunterData: '猎头数据分析',
        },
    },
    applicant: {
        name: '招聘系统',
        applicantDetail: {
            name: '招聘详情',
        },
        arrangeInterview: '安排面试',
        transmitData: '转发资料',
        filterResume: '筛选简历',
    },
    position: '职位',
    neitui: {
        name: '内部推荐',
    },
    huoshui: {
        name: '活水计划',
    },
    hunter: {
        name: '猎头平台',
        positions: '需求职位',
        candidates: '候选人',
        innerRegexRoute: {
            regex: postionRegex,
            recommend_candidate: '推荐候选人',
        },
    },
    job: {
        name: '职位',
    },
    interview: {
        evaluation: '面试评价',
        feedback: '面试信息',
        deliverInterview: '面试转交',
        changeInterview: '更改面试',
        cancelInterview: '取消面试',
    },
    transfer_all: {
        name: '批量转交职位',
    },
};


/* function isFunction(functionToCheck) {
    const getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
} */

function isObject(target) {
    return Object.prototype.toString.call(target) === '[object Object]';
}

function iteratorRoutes(accu, routes, idx) {
    const prop = routes[idx];
    const route = accu[prop];
    const len = routes.length - 1;

    if (accu.innerRegexRoute && accu.innerRegexRoute.regex.test(prop)) {
        return iteratorRoutes(accu.innerRegexRoute, routes, idx + 1);
    }

    if (route) {
        if (idx === len) {
            return route.name || route;
        }
        return iteratorRoutes(route, routes, idx + 1);
    }
    return accu.name || accu;
}

export default function parseRoute(rawUrl) {
    const url = rawUrl.slice(1);
    const routes = url.indexOf('/') ? url.split('/') : [url];
    // const len = routes.length - 1;
    const title = iteratorRoutes(routesMap, routes, 0);
    const isObjectTag = isObject(title);

    document.title = isObjectTag ? '滴滴招聘' : title;
}
